export function InspectionListCtrl (
  $scope,
  $state,
  $stateParams,
  $translate,
  INSPECTIONKEYS,
  INSPECTIONKEYSAU,
  INSPECTIONKEYSUS,
  inspections,
  messages,
  sessionObjAPI,
  workshopAPI
) {

  $scope.gridTitle   = $stateParams.key;
  $scope.inspections = inspections;
  $scope.loaded      = true;

  $scope.getColumns = function () {
    const session = sessionObjAPI.base();

    switch(session.company_settings.language) {
      case 'en-us':
        return INSPECTIONKEYSUS[$stateParams.key].columnDefs;
      case 'en-au':
        return INSPECTIONKEYSAU[$stateParams.key].columnDefs;
      default:
        return INSPECTIONKEYS[$stateParams.key].columnDefs;
    }
  };

  $scope.tableSettings = {
    columns: $scope.getColumns(),
    empty  : {
      text: $translate.instant('INSPECTIONS_SPACE.NO_INSPECTIONS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 10,
      pageSizes : [ 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/dashboard/inspection_widget_stats')
        .then(data => data[INSPECTIONKEYS[$stateParams.key].data])
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: INSPECTIONKEYS[$stateParams.key].sorting
  };

  $scope.getVehicleDetails = function() {
    angular.forEach($scope.inspections, row => {
       row.vehicle = row ? `${ row.make || '' } ${ row.model || '' } ${ row.plate_number || '' }` : '';
    });
  };

  $scope.getInspections = ( params ) => {
    return workshopAPI.get('/dashboard/' + INSPECTIONKEYS[$stateParams.key].route, [
      params.pageSize,
      params.offset,
      params.field || INSPECTIONKEYS[$stateParams.key].sorting.field,
      params.direction || INSPECTIONKEYS[$stateParams.key].sorting.direction
    ]).then (data => {
      $scope.inspections = data;
      $scope.getVehicleDetails();
      return $scope.inspections;
    });
  };

  $scope.refresh = function () {
    $state.reload();

    messages.show($translate.instant('JS_SPACE.MESSAGES.REFRESHED'), 'success');
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.inspection', {
        customer_id: event.row.customer_id,
        vehicle_id : event.row.vehicle_id,
        id         : event.row.id
    });
  };

  $scope.viewList = function (key) {
    $state.go('app.inspection-list', {
      key: key
    });
  };

  $scope.getInspections({ pageSize: 10, offset: 0 });
};